/**
 * Saves a file already in hand (e.g. one fetched with the user's token) to
 * the user's device, without leaving the page.
 */
export function saveFile(file: Blob, fileName: string): void {
  const objectUrl = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = fileName;
  document.body.append(link);
  link.click();
  link.remove();
  // Give the browser a moment to start the save before freeing it.
  setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}
